
export default {
  // Authentication
  "sign_in": "Connexion",
  "sign_up": "Inscription",
  "sign_in_with": "Se connecter avec",
  "sign_up_with": "S'inscrire avec",
  "email_address": "Adresse e-mail",
  "password": "Mot de passe",
  "forgot_password": "Mot de passe oublié ?",
  "dont_have_account": "Vous n'avez pas de compte ?",
  "already_have_account": "Vous avez déjà un compte ?",
  "create_account": "Créer un compte",
  "continue_with_email": "Continuer avec e-mail",
  "continue_with_google": "Continuer avec Google",
  "continue_with_github": "Continuer avec GitHub",
  "continue_with_twitter": "Continuer avec Twitter",
  "or": "ou",
  "email_sent": "E-mail envoyé",
  "check_email": "Vérifiez votre e-mail pour le code de réinitialisation",
  "reset_password": "Réinitialiser le mot de passe",
  "new_password": "Nouveau mot de passe",
  "confirm_password": "Confirmer le mot de passe",
  "passwords_dont_match": "Les mots de passe ne correspondent pas",
  "reset_link_sent": "Lien de réinitialisation envoyé",
  "temp_password_sent": "Mot de passe temporaire envoyé à votre e-mail",
  "reset_successful": "Réinitialisation réussie",
  "invalid_reset_link": "Lien de réinitialisation invalide",
  "account_details": "Détails du compte",
  "setup_security": "Configurer la sécurité",
  "security_questions": "Questions de sécurité",
  "answer": "Réponse",
  "next": "Suivant",
  "previous": "Précédent",
  "complete_signup": "Terminer l'inscription",
  "email_required": "L'e-mail est requis",
  "valid_email_required": "Une adresse e-mail valide est requise",
  "password_required": "Le mot de passe est requis",
  "username_required": "Le nom d'utilisateur est requis",
  "phone_required": "Le numéro de téléphone est requis",
  "answer_required": "La réponse est requise",
  "processing": "Traitement en cours...",
  "top_rated_airports": "Aéroports les mieux notés",
  "airports_to_watch": "Aéroports à surveiller",
  "welcome_back": "Bienvenue",
  "protect_film": "Protégez votre film, planifiez votre voyage",
  // New password reset translations
  "send_reset_link": "Envoyer un mot de passe temporaire",
  "reset_link_error": "Échec de l'envoi du lien de réinitialisation. Veuillez réessayer plus tard.",
  "email_delivery_not_configured": "L'envoi d'e-mails n'est pas configuré. Veuillez contacter l'administrateur.",
  "for_testing_use": "Pour les tests de développement, vous pouvez utiliser Supabase CLI ou Dashboard pour gérer les utilisateurs",
  "verification_code": "Code de vérification",
  "enter_verification_code": "Entrez le code à 6 chiffres envoyé à votre adresse e-mail",
  "invalid_code": "Code invalide ou expiré",
  "invalid_code_format": "Le code de vérification doit être un nombre à 6 chiffres",
  "password_reset_success": "Mot de passe réinitialisé avec succès",
  "password_too_short": "Le mot de passe doit comporter au moins 8 caractères",
  "back": "Retour",
  "verify_code": "Entrer le code de vérification",
  "email_not_received": "Vous n'avez pas reçu l'e-mail ?",
  "leave_page_warning": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter cette page ? Votre progression de réinitialisation de mot de passe sera perdue.",
  "reset_link_required": "Un lien de réinitialisation valide est requis pour réinitialiser votre mot de passe",
  // Rate limit messages
  "reset_rate_limit_exceeded": "Limite de tentatives dépassée. Veuillez attendre avant de réessayer.",
  "reset_rate_limit_message": "Veuillez attendre {{seconds}} secondes avant de demander un autre mot de passe temporaire.",
  "wait_before_retry": "Attendez avant de réessayer",
  // Temporary password messages
  "password_reset_required": "Vous devez changer votre mot de passe pour continuer",
  "temp_password_instructions": "Vous utilisez un mot de passe temporaire. Veuillez créer un nouveau mot de passe.",
  
  // Username dialog related translations
  "create_username": "Créer un nom d'utilisateur",
  "username_required_description": "Veuillez créer un nom d'utilisateur pour continuer. Votre nom d'utilisateur sera visible pour les autres utilisateurs.",
  "username": "Nom d'utilisateur",
  "username_placeholder": "Entrez un nom d'utilisateur",
  "username_requirements": "Le nom d'utilisateur ne peut contenir que des lettres, des chiffres et des tirets bas.",
  "save_username": "Enregistrer le nom d'utilisateur",
  "username_taken": "Ce nom d'utilisateur est déjà pris. Veuillez en essayer un autre.",
  "username_set_success": "Nom d'utilisateur défini avec succès !",
  "username_set_error": "Échec de la définition du nom d'utilisateur. Veuillez réessayer.",
  "auth_error": "Erreur d'authentification. Veuillez vous reconnecter.",
  "sign_in_success": "Connexion réussie !",
  "sign_in_failed": "Échec de la connexion",
  "completing_sign_in": "Finalisation de la connexion...",
  "please_wait": "Veuillez patienter pendant que nous vérifions vos identifiants.",
  "or_continue_with": "Ou continuer avec",
  "or_with_email": "Ou avec e-mail",
  "magic_link_sent": "Lien magique envoyé à votre e-mail",
  "magic_link_error": "Échec de l'envoi du lien magique. Veuillez réessayer plus tard.",
  "send_magic_link": "Envoyer un lien magique"
};
